import Vue from 'vue'
import Router from 'vue-router'
//登录
import login from '@/components/pages/login'
//获取凭证
import oAuth from '@/components/pages/oAuth'
//首页-个人中心
import index from '@/components/pages/index'
//健康卡管理
import personManage from '@/components/pages/personManage'
//健康卡信息详情
import healthCardDetails from '@/components/pages/healthCardDetails'
//新增健康卡
import addHealthCard from '@/components/pages/addHealthCard'
//预约挂号
import registration from '@/components/pages/registration'
//门诊医生列表
import outpatient from '@/components/pages/outpatient'
//医生详情
import doctorDetails from '@/components/pages/doctorDetails'
//预约挂号记录
import registrationRecord from '@/components/pages/registrationRecord'
//预约挂号记录详情
import registrationRecordDetails from '@/components/pages/registrationRecordDetails'
//门诊缴费
import pay from '@/components/pages/pay'
//住院信息
import hospitalInfo from '@/components/pages/hospitalInfo'
//确定挂号订单
import confirmRegistration from '@/components/pages/confirmRegistration'
//选择病人列表
import selectPerson from '@/components/pages/selectPerson'
//支付
import payment from '@/components/pages/payment'
//住院预缴款
import hospitalPay from '@/components/pages/hospitalPay'
//每日清单
import dailyListing from '@/components/pages/dailyListing'
//费用清单
import expensesList from '@/components/pages/expensesList'
//报告查询
import reportChange from '@/components/pages/reportChange'
//报告查询列表
import report from '@/components/pages/report'
//检验详情
import jyreport from '@/components/pages/jyreport'
//检查详情
import jcreport from '@/components/pages/jcreport'
//满意度调查
import satisfactionSurvey from '@/components/pages/satisfactionSurvey'
//交易记录
import payRecord from '@/components/pages/payRecord'
//交易记录详情
import payRecordDetails from '@/components/pages/payRecordDetails'
//体检套餐
import medicalPlan from '@/components/pages/medicalPlan'
//体检套餐详情
import medicalPlanDetails from '@/components/pages/medicalPlanDetails'
//体检套餐支付
import medicalPlanPay from '@/components/pages/medicalPlanPay'
//问卷调查
import questionnaire from '@/components/pages/questionnaire'
//新冠问卷调查
import questionnaire1 from '@/components/pages/questionnaire1'
//新冠问卷答案列表
import answerList from '@/components/pages/answerList'
//新冠问卷答案详情
import answerDetails from '@/components/pages/answerDetails'

Vue.use(Router)

export default new Router({
  // mode: 'history',  //去掉#
  routes: [
    { path: '/',
      redirect: '/index'
    },
    {
      path: '/login',
      name: 'login',
      component: login
    },
    {
      path: '/oAuth',
      name: 'oAuth',
      component: oAuth
    },
    {
      path: '/index',
      name: 'index',
      component: index
    },
    {
      path: '/personManage',
      name: 'personManage',
      component: personManage
    },
    {
      path: '/healthCardDetails',
      name: 'healthCardDetails',
      component: healthCardDetails
    },
    {
      path: '/addHealthCard',
      name: 'addHealthCard',
      component: addHealthCard
    },
    {
      path: '/registration',
      name: 'registration',
      component: registration
    },
    {
      path: '/outpatient',
      name: 'outpatient',
      component: outpatient
    },
    {
      path: '/doctorDetails',
      name: 'doctorDetails',
      component: doctorDetails
    },
    {
      path: '/registrationRecord',
      name: 'registrationRecord',
      component: registrationRecord
    },
    {
      path: '/registrationRecordDetails',
      name: 'registrationRecordDetails',
      component: registrationRecordDetails
    },
    {
      path: '/pay',
      name: 'pay',
      component: pay
    },
    {
      path: '/hospitalInfo',
      name: 'hospitalInfo',
      component: hospitalInfo
    },
    {
      path: '/confirmRegistration',
      name: 'confirmRegistration',
      component: confirmRegistration
    },
    {
      path: '/selectPerson',
      name: 'selectPerson',
      component: selectPerson
    },
    {
      path: '/payment',
      name: 'payment',
      component: payment
    },
    {
      path: '/hospitalPay',
      name: 'hospitalPay',
      component: hospitalPay
    },
    {
      path: '/dailyListing',
      name: 'dailyListing',
      component: dailyListing
    },
    {
      path: '/expensesList',
      name: 'expensesList',
      component: expensesList
    },
    {
      path: '/reportChange',
      name: 'reportChange',
      component: reportChange
    },
    {
      path: '/report',
      name: 'report',
      component: report
    },
    {
      path: '/jyreport',
      name: 'jyreport',
      component: jyreport
    },
    {
      path: '/jcreport',
      name: 'jcreport',
      component: jcreport
    },
    {
      path: '/satisfactionSurvey',
      name: 'satisfactionSurvey',
      component: satisfactionSurvey
    },
    {
      path: '/payRecord',
      name: 'payRecord',
      component: payRecord
    },
    {
      path: '/payRecordDetails',
      name: 'payRecordDetails',
      component: payRecordDetails
    },
    {
      path: '/medicalPlan',
      name: 'medicalPlan',
      component: medicalPlan
    },
    {
      path: '/medicalPlanDetails',
      name: 'medicalPlanDetails',
      component: medicalPlanDetails
    },
    {
      path: '/medicalPlanPay',
      name: 'medicalPlanPay',
      component: medicalPlanPay
    },
    {
      path: '/questionnaire',
      name: 'questionnaire',
      component: questionnaire
    },
    {
      path: '/questionnaire1',
      name: 'questionnaire1',
      component: questionnaire1
    },
    {
      path: '/answerList',
      name: 'answerList',
      component: answerList
    },
    {
      path: '/answerDetails',
      name: 'answerDetails',
      component: answerDetails
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js